export default __webpack_public_path__ + "static/media/avatar_placeholder_6.4ce8b4cc.jpg";